var _style, _path, _path2, _polygon, _rect, _rect2, _rect3, _rect4, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNonpocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st444{fill:#FFFFFF;stroke:#000000;stroke-width:3.49;stroke-miterlimit:10;}\n\t.st443{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st442{fill:#FFFFFF;stroke:#000000;stroke-width:1.16;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st444",
    d: "M59,360.2c0.8-14.9,2.1-30.2,3.6-46.1c4.8-49.5,11.7-90.3,17.2-118c4,0.2,7.8,0.5,11.7,0.6 c3.6,0.1,7.2,0.2,10.8,0.2c28.2,0.4,56.3-1.7,84.6-1.4c3.6,0,7.2,0.1,10.8,0.2c4.6,0.1,9.2,0.4,13.8,0.7 c-0.2,52.2-0.4,108.9-0.5,163.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st444",
    d: "M212.1,360.2c-0.2-54.8-0.4-111.5-0.6-163.7c4.9-0.3,9.8-0.6,14.6-0.7c3.6-0.1,7.2-0.2,10.8-0.2 c28.9-0.2,58,2,86.9,1.4c3.6,0,7.2-0.1,10.8-0.4c2.9-0.1,5.7-0.4,8.6-0.5c5.5,27.8,12.3,68.4,17.2,118c1.5,15.9,2.7,31.4,3.6,46.1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st443",
    points: "344.5,195.1 78.7,195.1 83.2,163.2 340,163.2 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 171.6,
    y: 175.9,
    transform: "matrix(2.111690e-02 -0.9998 0.9998 2.111690e-02 7.2902 370.0929)",
    className: "st442",
    width: 42.2,
    height: 10.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.2,
    y: 175.9,
    transform: "matrix(2.111690e-02 -0.9998 0.9998 2.111690e-02 -86.0882 274.7188)",
    className: "st442",
    width: 42.2,
    height: 10.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 225.9,
    y: 160.2,
    transform: "matrix(0.9998 -2.111691e-02 2.111691e-02 0.9998 -3.7762 4.9239)",
    className: "st442",
    width: 10.8,
    height: 42.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 323.6,
    y: 160.2,
    transform: "matrix(0.9998 -2.111691e-02 2.111691e-02 0.9998 -3.7544 6.987)",
    className: "st442",
    width: 10.8,
    height: 42.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st442",
    d: "M142.3,199.6c-2.3,25-4.5,40.9-6.9,65.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st442",
    d: "M285.4,199.6c2.3,25,4.5,38.6,6.9,63.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonpocket);
export default __webpack_public_path__ + "static/media/NON POCKET.b29c2cdd311784e469e5211837e22253.svg";
export { ForwardRef as ReactComponent };